import { Checkbox } from "@components/ui/checkbox"
import { cn } from "@components/ui/lib/utils"
import { FormControl, FormField, FormItem } from "@components/ui/form"
import type { UseFormReturn } from "react-hook-form"
import type { TVerificationForm } from "@utils/verificationScriptsUtils"

type TVerificationChecklistProps = {
  script: string[]
  form: UseFormReturn<TVerificationForm>
  completed?: boolean
}

export const VerificationChecklist = ({
  script,
  form,
  completed = false,
}: TVerificationChecklistProps) => {
  return (
    <div className="tw:flex tw:flex-col tw:gap-2">
      <div className="tw:flex tw:justify-between tw:gap-2 tw:border-b tw:pb-1 tw:font-semibold">
        <span>Verification Step</span>
        <span>Verified?</span>
      </div>

      {script?.map(
        (itemText, index) =>
          itemText && (
            <div
              key={`scriptItem-${index}`}
              className="tw:flex tw:justify-between tw:gap-3 tw:p-2 tw:odd:bg-gray-100"
            >
              <span dangerouslySetInnerHTML={{ __html: itemText }} />
              <FormField
                control={form.control}
                name={`verificationItem.${index}`}
                rules={{ required: true }}
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <Checkbox
                        checked={!!field.value || completed}
                        onCheckedChange={field.onChange}
                        className={cn(
                          "tw-block tw:h-6 tw:w-6",
                          field.value
                            ? "tw:border-green-500"
                            : "tw:border-red-600",
                        )}
                      />
                    </FormControl>
                  </FormItem>
                )}
              />
            </div>
          ),
      )}
    </div>
  )
}
